/* assets/section-use-scenario.js */
class UseScenarioSection {
  constructor(container) {
    this.container = container;
    this.cards = [];
    this.swiper = null;
    this.mediaQuery = window.matchMedia('(max-width: 749px)');
    this.onEnter = this.onEnter.bind(this);
    this.onLeave = this.onLeave.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    this.init();
  }

  init() {
    this.initVideos();
    this.initCarousel();
  }

  initVideos() {
    this.container.querySelectorAll('.scenario-card--has-video').forEach((card) => {
      const video = card.querySelector('.scenario-card__video');
      if (!video) return;

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.preload = 'metadata';

      card.addEventListener('mouseenter', this.onEnter);
      card.addEventListener('mouseleave', this.onLeave);
      card.addEventListener('focusin', this.onEnter);
      card.addEventListener('focusout', this.onLeave);

      this.cards.push({ card, video });
    });
  }

  initCarousel() {
    const el = this.container.querySelector('[data-carousel-mobile]');
    if (!el) return;

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.onBreakpointChange);
    } else {
      this.mediaQuery.addListener(this.onBreakpointChange);
    }

    this.syncCarousel();
  }

  syncCarousel() {
    const el = this.container.querySelector('[data-carousel-mobile]');
    if (!el || typeof Swiper === 'undefined') return;

    if (this.mediaQuery.matches) {
      if (this.swiper) return;

      const gap = parseInt(el.dataset.gap || '24', 10);

      this.swiper = new Swiper(el, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        speed: 450,
        grabCursor: true,
        watchOverflow: true,
        resistanceRatio: 0.65,
        observer: true,
        observeParents: true,
      });

      this.bindNaturalRatioUpdates(el);
      return;
    }

    this.destroyCarousel();
  }

  bindNaturalRatioUpdates(el) {
    if (!el.closest('.use-scenario__items--ratio-natural')) return;

    const update = () => {
      if (this.swiper && typeof this.swiper.update === 'function') {
        this.swiper.update();
      }
    };

    el.querySelectorAll('.scenario-card__image').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', update, { once: true });
    });

    requestAnimationFrame(update);
  }

  onBreakpointChange() {
    this.syncCarousel();
  }

  destroyCarousel() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true);
    }
    this.swiper = null;
  }

  onEnter(event) {
    if (!window.matchMedia('(hover: hover)').matches) return;

    const video = event.currentTarget.querySelector('.scenario-card__video');
    if (!video) return;

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  }

  onLeave(event) {
    const video = event.currentTarget.querySelector('.scenario-card__video');
    if (!video) return;

    video.pause();
    video.currentTime = 0;
  }

  destroy() {
    this.cards.forEach(({ card, video }) => {
      card.removeEventListener('mouseenter', this.onEnter);
      card.removeEventListener('mouseleave', this.onLeave);
      card.removeEventListener('focusin', this.onEnter);
      card.removeEventListener('focusout', this.onLeave);
      video.pause();
    });
    this.cards = [];

    if (this.mediaQuery) {
      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.onBreakpointChange);
      } else if (this.mediaQuery.removeListener) {
        this.mediaQuery.removeListener(this.onBreakpointChange);
      }
    }

    this.destroyCarousel();
  }
}

const useScenarioInstances = new WeakMap();

function initUseScenario(root = document) {
  root.querySelectorAll('.use-scenario').forEach((section) => {
    const existing = useScenarioInstances.get(section);
    if (existing) existing.destroy();
    useScenarioInstances.set(section, new UseScenarioSection(section));
  });
}

function destroyUseScenario(root = document) {
  root.querySelectorAll('.use-scenario').forEach((section) => {
    const existing = useScenarioInstances.get(section);
    if (existing) {
      existing.destroy();
      useScenarioInstances.delete(section);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initUseScenario());

document.addEventListener('shopify:section:load', (event) => {
  initUseScenario(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  destroyUseScenario(event.target);
});
